export default __webpack_public_path__ + "static/media/1774.03bb95f5.png";